import { render, staticRenderFns } from "./ActiveOrders.vue?vue&type=template&id=f70f572c"
import script from "./ActiveOrders.vue?vue&type=script&lang=js"
export * from "./ActiveOrders.vue?vue&type=script&lang=js"
import style0 from "./ActiveOrders.vue?vue&type=style&index=0&id=f70f572c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports